import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <img
              src="/images/SWEDEN_nobg.png"
              alt="TrafikBevakning"
              className="site-footer__logo"
              loading="lazy"
            />
            <p className="site-footer__tagline">
              Vi erbjuder full återbetalning om tjänsten inte fungerar som annonserat.
            </p>
          </div>

          <div className="site-footer__column">
            <h3 className="site-footer__heading">Meny</h3>
            <nav className="site-footer__nav" aria-label="Sidnavigering">
              <Link to="/">Hem</Link>
              <Link to="/plans">Priser</Link>
              <Link to="/register">Skapa konto</Link>
              <Link to="/account">Mitt konto</Link>
            </nav>
          </div>

          <div className="site-footer__column">
            <h3 className="site-footer__heading">Kontakt</h3>
            <a href="mailto:Kontakt@Trafikbevakning.com" className="site-footer__email">
              Kontakt@Trafikbevakning.com
            </a>
          </div>
        </div>

        <div className="site-footer__bottom">
          <p className="site-footer__copyright">© TrafikBevakning.com {currentYear}</p>
          <nav className="site-footer__legal" aria-label="Juridiska länkar">
            <Link to="/dataskyddspolicy">Dataskyddspolicy</Link>
            <Link to="/integritetspolicy">Integritetspolicy</Link>
            <Link to="/anvandavillkor">Användarvillkor</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
